import { render, staticRenderFns } from "./krsbib-header.vue?vue&type=template&id=34713f2e"
import script from "./krsbib-header.vue?vue&type=script&lang=js"
export * from "./krsbib-header.vue?vue&type=script&lang=js"
import style0 from "./krsbib-header.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports